import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btnWrapper: {
    position: "relative",
  },
  textCenter: {
    backgroundColor: "red",
  },

  // container principal da lista
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: 12,
    overflowY: "auto",
    width: "100%",
    scrollBehavior: "smooth",

    "&::-webkit-scrollbar": {
      height: 6,
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)",
      borderRadius: 8,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(0,0,0,0.35)",
    },
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0,0,0,0.2) transparent",
  },

  // container quando não há resultados
  emptyContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    marginTop: 10,
    width: "100%",
    padding: "16px 24px",
  },

  emptyText: {
    color: theme.palette.neutral400,
    fontWeight: 400,
    fontSize: 14,
  },

  registerOption: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    color: theme.palette.primary200,
    fontWeight: 600,
    fontSize: 16,
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.8,
    },
  },
}))

export default useStyles
